import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import StockorderEditFormImpl from './StockorderEditFormImpl';
import StockorderList from './StockorderList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import StockorderListView from './StockorderListView'


export default function StockorderDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.manufslice.stockorderDashboard);
  const [ stockorderId, setStockorderId] = React.useState('');
  const [reloadStockorderList, setReloadStockorderList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <StockorderEditFormImpl 
            setReloadStockorderList={setReloadStockorderList}
            stockorderId={stockorderId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <StockorderListView 
                      setStockorderId = {setStockorderId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
